const Amc = {

    // FIELDS
    "amc": "AMC",
    "contract_name": "Contract Name",
    "external_vendor": "External Vendor",
    "start_date": "Start Date",
    "end_date": "End Date",
    "repaired_charges": "Repaired Charges",
    "replace_charges": "Replace Charges",
    "type": "Type",
    "priority": "Priority",
    "service_department": "Service Department",
    "note": "Note",
    "search": "Search",

    // PAGE HEADER
    "list_title": "AMC",
    "filter_title": "AMC Filter",
    "details_title": "AMC Details",

    // TABLE HEADER
    "table_amc_code": "AMC Code",
    "table_contract_name": "Contract Name",
    "table_vendor": "External Vendor",
    "table_start_date": "Start Date",
    "table_end_date": "End Date",
    "table_type": "Type",
    "table_asset_count": "Assets",
    "table_status": "Status",
    "table_priority": "Priority",

    // ERROR
    "error_contract_name": "Enter Contract Name",
    "error_external_vendor": "Select External Vendor",
    "error_start_date": "Select Start Date",
    "error_end_date": "Select End Date",
    "error_type": "Select Type",
    "error_priority": "Select Priority",
    "error_service_department": "Select Service Department",

}

export default Amc;
